import PageLayout from "components/shared/pageLayout/PageLayout";
import BalanceCheck from "components/balanceCheck/BalanceCheck";

function SaldocheckPage() {
    return (
        <PageLayout
            slug="saldocheck"
            title="Saldocheck | Lees! Cadeau"
            description="Bekijk hier het saldo van jouw Lees! Cadeau."
        >
            <BalanceCheck />
        </PageLayout>
    );
}

export default SaldocheckPage;
